export default __webpack_public_path__ + "static/favicon-f518b416ca004663041c513f9ef61c29.ico";